export default __webpack_public_path__ + "static/lilikoi-48f65b59b7267ef59579144b9a9ea7ff.webp";